// src/components/TeeSelector.js
import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const TeeSelector = ({ teeOptions, selectedTee, setSelectedTee }) => {
  const theme = useTheme();

  return (
    <FormControl fullWidth variant="outlined" sx={{ mt: 2 }}>
      <InputLabel id="tee-selector-label">Select Tee</InputLabel>
      <Select
        labelId="tee-selector-label"
        value={selectedTee ? selectedTee.tee_name : ""}
        onChange={(e) => {
          const selected = teeOptions.find(
            (tee) => tee.tee_name === e.target.value
          );
          console.log("TeeSelector: Selected tee:", selected);
          setSelectedTee(selected);
        }}
        label="Select Tee"
        MenuProps={{
          PaperProps: {
            style: {
              backgroundColor: theme.palette.background.paper,
            },
          },
        }}
      >
        {teeOptions.map((tee) => (
          <MenuItem key={tee.tee_name} value={tee.tee_name}>
            {tee.tee_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TeeSelector;